import React from 'react';
import { useTranslation } from 'react-i18next';

export const EXECUTION_STATUSES = [
  'progress',
  'ready_for_departure',
  'in_transit',
  'arrived',
  'clearance_transport',
  'delivered',
] as const;

export type ExecutionStatus = (typeof EXECUTION_STATUSES)[number];

const STATUS_I18N_KEYS: Record<ExecutionStatus, string> = {
  progress:             'shipment_status_progress',
  ready_for_departure:  'shipment_status_ready_for_departure',
  in_transit:           'shipment_status_in_transit',
  arrived:              'shipment_status_arrived',
  clearance_transport:  'shipment_status_clearance_transport',
  delivered:            'shipment_status_delivered',
};

interface ShipmentStatusBadgeProps {
  status: string | null | undefined;
  isDraft?: boolean;
}

const ShipmentStatusBadge: React.FC<ShipmentStatusBadgeProps> = ({ status, isDraft }) => {
  const { t } = useTranslation();

  if (isDraft || !status) {
    return (
      <span className="shipment-status-badge shipment-status-badge--draft">
        {t('shipment_status_draft')}
      </span>
    );
  }

  const key = STATUS_I18N_KEYS[status as ExecutionStatus] ?? 'shipment_status_progress';
  return (
    <span className={`shipment-status-badge shipment-status-badge--${status}`}>
      {t(key)}
    </span>
  );
};

export default ShipmentStatusBadge;
